"use strict"
import axios from "axios";
import { getAuthHeaders } from "./UserTokenService";

export const getRequest = async (api_url, requiresToken = true) => {
  try {
      const config = requiresToken ? getAuthHeaders() : {};
      const response = await axios.get(api_url, config);
      return response;
  } catch (e) {
      console.log(e);
      throw e;
  }
}

export const getRequestParam = async (api_url, param = null, requiresToken = true) => {
  try {
      const config = requiresToken ? getAuthHeaders() : {};
      const response = await axios.get(api_url, {
        ...config, 
        params: param
      });
      return response;
  } catch (e) {
      console.log(e);
      throw e;
  }
}

export const postRequest = async (api_url, post_request, requiresToken = true) => {
  try {
      const config = requiresToken ? getAuthHeaders() : {};
      const response = await axios.post(api_url, post_request, config);
      return response;
  } catch (e) {
      console.log(e);
      throw e;
  }
}

export const patchRequest = async (api_url, post_request, requiresToken = true) => {
  try {
      const config = requiresToken ? getAuthHeaders() : {};
      const response = await axios.patch(api_url, post_request, config);
      return response;
  } catch (e) {
      console.log(e);
      throw e;
  }
}
